<template>
  <div id="modal-add-news-trend">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group">
        <label for="input-nama">Judul</label>
        <div class="form-group">
          <input
            type="text"
            name="nama"
            value=""
            id="input-judul"
            class="form-control"
            placeholder="Judul"
            required
            v-model="judul"
          />
        </div>
      </div>
      <div class="form-group">
        <label for="input-username">Deskripsi</label>
        <div class="form-group">
          <textarea
            class="form-control"
            id="content"
            name="content"
            rows="15"
            v-model="deskripsi"
          />
        </div>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-primary">Simpan</button>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";

$.pgNotification = notif;

export default {
  name: "modal_add_news_trend",
  data() {
    return {
      judul: null,
      deskripsi: null,
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    submitForm: function () {
      if (this.judul != null) {
        let params = {
          title: this.$sanitize(this.judul),
          description:
            this.deskripsi == null ? "-" : this.$sanitize(this.deskripsi),
          id_project: this.id_project,
        };
        let api = process.env.VUE_APP_API_URL + "newstrend/save";
        this.$http
          .post(api, params)
          .then((response) => {
            if (response.status == 200) {
              this.$parent.$parent.getData();

              $("#modalSlideUp").modal("hide");
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> News Trend berhasil ditambahkan!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          })
          .catch(() => {
            $("#modalSlideUp").modal("hide");
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat menambahkan User!',
                position: "top",
                timeout: 5000,
                type: "danger",
              })
              .show();
          });
      } else {
        alert("pastikan semua field terisi");
      }
    },
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
}
select {
  cursor: pointer;
}
</style>